import { useState } from 'react'
import constate from 'constate'

import { Address } from '@ecm/data/Address'

export type SearchSource = 'map' | 'text' | ''

const TWO_HUNDRED_FIFTY_MILES = 402336

type VisibleAddressProviderType = {
  initialAddresses: Address[]
}

function useVisibleAddresses({ initialAddresses }: VisibleAddressProviderType) {
  const [visibleAddresses, setVisibleAddresses] = useState<Address[]>(initialAddresses)
  const [activeSearch, setActiveSearch] = useState<boolean>(false)
  const [searchSource, setSearchSource] = useState<SearchSource>('')
  const [searchValue, setSearchValue] = useState<string>('')
  const [hasActiveSearch, setHasActiveSearch] = useState(false)
  const [isFirstZoomAfterSearch, setIsFirstZoomAfterSearch] = useState(false)

  return {
    TWO_HUNDRED_FIFTY_MILES,
    activeSearch,
    hasActiveSearch,
    initialAddresses,
    isFirstZoomAfterSearch,
    searchSource,
    searchValue,
    setActiveSearch,
    setHasActiveSearch,
    setIsFirstZoomAfterSearch,
    setSearchSource,
    setSearchValue,
    setVisibleAddresses,
    visibleAddresses,
  }
}

export const [VisibleAddressesProvider, useVisibleAddressesContext] = constate(useVisibleAddresses)
